import React, { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import AdminDetailsScreen from  '@/components/page/OrgSettings/Users/AdminDetails/AdminDetailsScreen';

//context
import { OrgSettingsContext } from '@/context/OrgSettings';
import { OrgSettingsUsersContext } from '@/context/OrgSettingsUsersContext';



const AdminDetailsPortal = () => {    
    const { setOrgId } = useContext(OrgSettingsContext);
    const { setUserId } = useContext(OrgSettingsUsersContext);

    const targetContainer = document.getElementById('react-organisation-role-container');
    
    if(!targetContainer) {
        return null;
    } else {
        setOrgId(targetContainer.getAttribute('data-org-id'))
        setUserId(targetContainer.getAttribute('data-user-id'))
    }

    return ReactDOM.createPortal(
        <AdminDetailsScreen />, targetContainer
    );
}


export default AdminDetailsPortal;